import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Loader2, CheckCircle2, XCircle } from "lucide-react";
import { useTranslation } from "react-i18next";
import { api } from "../../lib/api";

const FINAL_OK = ["captured"];
const FINAL_KO = ["failed", "cancelled", "expired"];
const MAX_POLLS = 40;

// Retour navigateur Mobupay : n'est JAMAIS une preuve. Lecture seule du statut confirmé côté serveur (webhook signé).
export default function PaymentReturnPage() {
  const { t } = useTranslation("billing");
  const [params] = useSearchParams();
  const ws = params.get("ws");
  const checkout = params.get("checkout");
  const [state, setState] = useState({ status: "pending" });
  const [polls, setPolls] = useState(0);

  useEffect(() => {
    if (!ws || !checkout) { setState({ status: "invalid" }); return; }
    let stop = false;
    const tick = async (n) => {
      try {
        const { data } = await api.get(`/workspaces/${ws}/billing/checkouts/${checkout}`);
        if (stop) return;
        setState(data);
        if (FINAL_OK.includes(data.status) || FINAL_KO.includes(data.status)) return;
      } catch (e) { if (!stop) setState({ status: "invalid" }); return; }
      if (n + 1 >= MAX_POLLS) { setState((s) => ({ ...s, status: "timeout" })); return; }
      setPolls(n + 1);
      setTimeout(() => !stop && tick(n + 1), 3000);
    };
    tick(0);
    return () => { stop = true; };
  }, [ws, checkout]);

  const ok = FINAL_OK.includes(state.status);
  const ko = FINAL_KO.includes(state.status) || state.status === "invalid";
  const key = ok ? "confirmed" : ko ? (state.status === "invalid" ? "invalid" : "failed") : state.status === "timeout" ? "timeout" : "pending";
  return (
    <div className="flex justify-center py-12 px-4">
      <div data-testid="payment-return-page" data-status={key} className="glass rounded-2xl p-6 sm:p-8 w-full max-w-md">
        <div className="flex items-center gap-2 mb-3">
          {ok ? <CheckCircle2 className="w-6 h-6 text-emerald-600" /> : ko ? <XCircle className="w-6 h-6 text-red-600" />
            : <Loader2 className="w-6 h-6 animate-spin text-slate-500" />}
          <h1 data-testid="payment-return-title" className="font-heading text-xl font-semibold text-slate-900">{t(`v1.ret.${key}.title`)}</h1>
        </div>
        <p data-testid="payment-return-text" className="text-sm text-slate-600">{t(`v1.ret.${key}.text`)}</p>
        {state.dolibarr_ref && <p className="text-xs text-slate-500 mt-3">{t("v1.ret.invoice", { ref: state.dolibarr_ref })}</p>}
        {key === "pending" && <p className="text-[11px] text-slate-400 mt-2" aria-live="polite">{t("v1.ret.checking", { n: polls + 1 })}</p>}
        <Link to="/compte" data-testid="payment-return-back" className="mt-6 inline-block text-sm font-medium text-emerald-700 underline">{t("v1.ret.back")}</Link>
      </div>
    </div>
  );
}
